import {
    GET_TODO_LIST_DATA_SUCCESS,
    GET_DIARY_LOGS_SUCCESS,
    CHANGE_SELECTED_DIARY,
    RESET_LISTING_DATA,
    RESET_LISTING_LOG_DATA,
    GET_DIARY_DETAIL_SUCCESS,
    COMPLETE_DIARY_SUCCESS_LISTING,
    CANCEL_DIARY_SUCCESS_LISTING,
    UPDATE_TODO_LIST_DATA_SUCCESS,
    UPDATE_CAPTION_TODOLIST_SUCCESS,
    SHOW_LEFT_LISTING_LOADER,
    HIDE_LEFT_LISTING_LOADER,
    SHOW_RIGHT_LISTING_LOADER,
    HIDE_RIGHT_LISTING_LOADER,
    CHANGE_ACTIVE_TAB,
    SET_SELECTED_DIARY_DETAIL,
    UPDATE_DIARY_LIST_SUCCESS
} from '../actions/actionConstants';
import moment from 'moment';
import {mergeArrayByKey} from "../../../common/util";
import { DEFAULT_TIME_FORMAT,DEFAULT_TIME_AT_FORMAT } from '../../../common/constants';

const initialState = {
    listingData: {},
    logs: {},
    selectedDiary: null,
    selectedDiaryDetail:{},
    galleryData:[],
    activeTab:0,
    detail: {},
    filterOption:{priority:'ALLP',status:'1', searchKey:''},
    isLeftLoading:false,
    isRightLoading:false
};

export const getFileGalleryData = (item)=>{
    const data = item.Files.filter((filteredData)=>filteredData.FileType=='Image');
    return data.filter(item=>item && Object.keys(item).length>0);
}

export const detailMapping = (data,isToolTip) => {
    let fileData = {
        FileGuid: data.FileGuid,
        FileSize: data.FileSizeView,
        FileType: data.FileType,
        FileUploadOn: data.FileUploadOn,
        FileUploadUtcOn: data.FileUploadUtcOn,
        PreetyFileUploadOn: data.PreetyFileUploadOn,
        IsImageType: data.IsImageType,
        FileUrl: data.FileUrl,
        FilePreviewUrl: data.FilePreviewUrl,
        FileMaximumUrl: data.FileMaximumUrl,
        ImageUrl: data.ImageUrl,
        ImageCaptionUrl: data.ImageCaptionUrl,
        Caption: data.Caption,
        VideoFileName: data.VideoFileName,
        VideoThumbFileName: data.VideoThumbFileName,
        FileName: data.TodoFile,
        CanModifyCaption: (isToolTip || data.Status == "CANCELLED") ? false : true,
        Id:data.TodoId,
        NoteCategory:'todo',
        NoteId:data.TodoId
        // diarySponsor
    };
    fileData = fileData.FileGuid ? {
        Files: [...fileData]
    }
        :
        {
            Files: []
        };

    Object.keys(fileData).forEach(e => delete data[e]);
    return Object.assign({}, data, { fileData: fileData})
};

const listingMapping = data => {
    return data?.map(item => {
        return Object.assign({}, item, { due_date: moment(item.due_date).format(DEFAULT_TIME_AT_FORMAT) })
    })
}

const getToDoListSuccess = (state, action, payload) => {
    const {response, filterOption, isMobileView } = action.payload;
    const selectedDiary =
        isMobileView
            ? 0
            : !filterOption?.searchKey?.trim()?.length
                ? response?.data?.[0]?.TodoId ?? null
                : null;

    return {
        ...state,
        listingData: response,
        selectedDiary,
        filterOption,
    };
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CHANGE_ACTIVE_TAB:
            return Object.assign({},state,{activeTab:action.payload.activeTab}); 
        case SHOW_LEFT_LISTING_LOADER:
        case HIDE_LEFT_LISTING_LOADER:
            return Object.assign({},state,{isLeftLoading:action.payload});
        case SHOW_RIGHT_LISTING_LOADER:
        case HIDE_RIGHT_LISTING_LOADER:
            return Object.assign({},state,{isRightLoading:action.payload});

        case GET_TODO_LIST_DATA_SUCCESS: {
            return getToDoListSuccess(state, action, action.payload);
        }
        case UPDATE_TODO_LIST_DATA_SUCCESS: {
            const currentListData = state.listingData.Data;
            const mergeList = mergeArrayByKey(currentListData, action.payload.Data, 'id');
            const newData = Object.assign({}, action.payload, { Data: mergeList });
            return Object.assign({}, state, { listingData: newData, selectedDiary: state.selectedDiary || mergeList[0] });
        }
        case GET_DIARY_LOGS_SUCCESS: {
            let creationLog = {
                OwnerView: {
                    DisplayName: action.payload.creatorName,
                    creatorProfileUrl: action.payload.creatorProfileUrl,
                    ProfileFullImage: action.payload.creatorProfileImage
                },
                NonFormatedUpdatedDate: action.payload.createdDate,
                Field: "CreationLog"
            };
            Object.keys(creationLog).forEach(e => delete action.payload[e]);
            let todoLogs=[];
            if(action.payload.todoLogs){
                todoLogs={todoLogs:action.payload.todoLogs.concat(creationLog)};
            }
            else{
                todoLogs={todoLogs:[].concat(creationLog)};
            }
            return Object.assign({}, state, { logs: todoLogs });
        }
        case CHANGE_SELECTED_DIARY:
            return Object.assign({}, state, { selectedDiary: action.payload.id });
            
        case SET_SELECTED_DIARY_DETAIL:
            let selectedDiaryDetail ={};
            const {can_completeorreopen_diary, can_edit_own_todo, can_edit_todo} = action?.payload?.userPermission;

            const isEditable = (item) => {
                return (can_edit_todo && !!item?.module_type) || (can_edit_own_todo && !item?.module_type)
            }

            state.listingData.data.map(item=>{
                if(item.todo_id == state.selectedDiary){
                    let menuActions=[];
                    if (item.status == 'COMPLETED') {
                        if (can_completeorreopen_diary) menuActions.push('2');
                    }else{
                        if (can_completeorreopen_diary) menuActions.push('0');
                        if (isEditable(item)) menuActions.push('1');
                    }
                    menuActions.push('3');
                    
                    selectedDiaryDetail={
                        id:item.todo_id,
                        title:item.title,
                        status:item.status,
                        module:item?.module,
                        moduleId:item?.moduleId,
                        menuActions:menuActions.sort()
                    }
                }
            });
            return Object.assign({},state,{selectedDiaryDetail:selectedDiaryDetail});

        case RESET_LISTING_DATA:
            return Object.assign({}, state, initialState);
        case RESET_LISTING_LOG_DATA:
            return Object.assign({}, state, { logs: {},detail: {} });
        case GET_DIARY_DETAIL_SUCCESS:
            const mappedData = detailMapping(action.payload,false);
            const galleryData = getFileGalleryData(mappedData.fileData)
            return Object.assign({}, state, { detail: mappedData,galleryData:[galleryData]});

        case COMPLETE_DIARY_SUCCESS_LISTING:
            const { id, isComplete,completedDate } = action.payload;
            let newStatus = "",menuActions=[];
            if (isComplete) {
                newStatus = 'COMPLETED';
                menuActions = ['3', '4'];
            }
            else {
                newStatus = 'OPEN';
                menuActions = ['0', '1', '2', '4'];
            }
            const newData = state.listingData.Data.map(item => {
                if (item.TodoId == id) {
                    return Object.assign({},item,{Status:newStatus})
                }
                return item;
            });
            const newListingData = Object.assign({}, state.listingData, { Data: newData });
            const newSelectedDiaryDetailData = Object.assign({},state.selectedDiaryDetail,{Status:newStatus , menuActions:menuActions});
            const newDetailData = Object.assign({},state.detail,{PreetyCompletedDate:completedDate,Status:newStatus});
            return Object.assign({}, state, { listingData: newListingData, selectedDiaryDetail: newSelectedDiaryDetailData,detail:newDetailData });

        case CANCEL_DIARY_SUCCESS_LISTING:
            const data = state.listingData.Data.map(item => {
                if (item.TodoId == action.payload.id) {
                    return Object.assign({},item,{Status:"CANCELLED"})
                }
                return item;
            });
            const listingData = Object.assign({}, state.listingData, { Data: data });
            const Data = Object.assign({},state.selectedDiaryDetail,{Status:"CANCELLED" });
            const newDetail =  Object.assign({},state.detail,{PreetyDeletedDate:moment.utc().format(DEFAULT_TIME_FORMAT),Status:"CANCELLED"});
            return Object.assign({}, state, { listingData: listingData, selectedDiaryDetail: Data, detail:newDetail });

        case UPDATE_CAPTION_TODOLIST_SUCCESS:
            const fileData= state.detail.fileData.Files.map(item=>{
                if(item.Id==action.payload.id){
                    return Object.assign({},item,{Caption:action.payload.caption})
                }
                return item;
            })
            const updateDetail = Object.assign({},state.detail,{fileData:{Files: [...fileData]}});
            return Object.assign({}, state, {detail: updateDetail });
        
        case UPDATE_DIARY_LIST_SUCCESS:
            let updatedData = state.listingData.Data.map(item => {
                if (item.TodoId == action.payload.TodoId) {
                    const actionData = Object.assign({}, action.payload, { DueDate: moment(action.payload.DueDate).format(DEFAULT_TIME_AT_FORMAT) });
                    return Object.assign({},item,actionData);
                }
                return item;
            });
            updatedData = Object.assign({}, state.listingData, { Data: updatedData });
            let updateSelectedDiary = Object.assign({},state.selectedDiaryDetail,{
                Title:action.payload.Title,
            })
            const updatedDetailData = Object.assign({},state.selectedDiaryDetail,detailMapping(action.payload,false));
            return Object.assign({}, state, { listingData: updatedData, selectedDiaryDetail: updateSelectedDiary, detail:updatedDetailData });
        default:
            return state;
    }
}
